const ENV = {
  DEV: 'development',
  STAGING: 'staging',
  PROD: 'production',
}

// Development config
const devConfig = {
  customerFrontend: 'http://localhost:3002/index.html',
  storageFrontend: 'http://localhost:3003/index.html',
  rentalFrontend: 'http://localhost:3005/index.html',
  clusterFrontend: 'https://cluster-admin-iframe-app.s3-eu-west-1.amazonaws.com/index.html',
  driverFrontend: 'https://driver-iframe-app.s3-eu-west-1.amazonaws.com/index.html',
  consumerServer: 'http://localhost:3030',
  customerBackend: 'http://localhost:4000',
  driverBackend: 'https://yyto1gogm8.execute-api.eu-west-1.amazonaws.com/api/prod',
  storageBackend: 'http://localhost:3007/api',
}

// Staging config
const stagingConfig = {
  customerFrontend: 'https://customer-iframe-app.s3-eu-west-1.amazonaws.com/index.html',
  storageFrontend: 'https://storage-frontend-v2.s3-eu-west-1.amazonaws.com/index.html',
  rentalFrontend: 'https://rental-iframe-app.s3-eu-west-1.amazonaws.com/index.html',
  clusterFrontend: 'https://cluster-admin-iframe-app.s3-eu-west-1.amazonaws.com/index.html',
  driverFrontend: 'https://driver-iframe-app.s3-eu-west-1.amazonaws.com/index.html',
  consumerServer: 'https://staging.qlocx.com/consumer',
  customerBackend: 'https://gskjr6no83.execute-api.eu-west-1.amazonaws.com/staging',
  storageBackend: 'https://staging.qlocx.com/storage/api',
  driverBackend: 'https://hpyp4goke2.execute-api.eu-west-1.amazonaws.com/staging',
}

// Production config
const productionConfig = {
  customerFrontend: 'https://customer-iframe-app.s3-eu-west-1.amazonaws.com/index.html',
  storageFrontend: 'https://storage-frontend-v2.s3-eu-west-1.amazonaws.com/index.html',
  rentalFrontend: 'https://rental-iframe-app.s3-eu-west-1.amazonaws.com/index.html',
  clusterFrontend: 'https://cluster-admin-iframe-app.s3-eu-west-1.amazonaws.com/index.html',
  driverFrontend: 'https://driver-iframe-app.s3-eu-west-1.amazonaws.com/index.html',
  consumerServer: 'https://consumer.qlocx.com',
  customerBackend: 'https://ip2h86tdgk.execute-api.eu-west-1.amazonaws.com/prod',
  driverBackend: 'https://oozjh56py1.execute-api.eu-west-1.amazonaws.com/prod',
  storageBackend: 'https://storagebackend.o6jo571ucj14o.eu-west-1.cs.amazonlightsail.com/api',
}

// Select config based on environment
const getConfig = () => {
  // Check for explicit environment override
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV

  let configName = ENV.DEV
  if (env === ENV.STAGING) configName = ENV.STAGING
  if (env === ENV.PROD) configName = ENV.PROD

  // Log which environment we're using (helps verify deployment config)
  console.log(`[API Config] Environment: ${env}, Using: ${configName} config`)

  switch (env) {
    case ENV.PROD:
      return productionConfig
    case ENV.STAGING:
      return stagingConfig
    case ENV.DEV:
    default:
      return devConfig
  }
}

const config = getConfig()

export const { customerFrontend, storageFrontend, rentalFrontend, clusterFrontend, driverFrontend, consumerServer, customerBackend, driverBackend, storageBackend } = config
